// export DsfTextbox from "./textbox.vue";
// export DsfTextarea from "./textarea.vue";
// export DsfUEditor from "./ueditor.vue";
// export DsfAutoComplete from "./autoComplete.vue";
// export DsfNumeration from "./numeration.vue";
// export DsfCurNumber from './carNumber.vue'
// export DsfWangEditor from './neweditor.vue'
// export DsfCodeEditor from './codeEditor.vue'

export DsfTextbox from "./textbox.vue";
export DsfTextarea from "./textarea.vue";
// export DsfAutoComplete from "./autoComplete.vue";
// export DsfNumeration from "./numeration.vue";
// export const DsfTextbox=dsf.defineLazyComponent('DsfTextbox',()=>require("./textbox.vue"));
export const DsfAutoComplete=dsf.defineLazyComponent('DsfAutoComplete',()=>require('./autoComplete'));
export const DsfNumeration=dsf.defineLazyComponent('DsfNumeration',()=>require('./numeration'));


export const DsfWangEditor =dsf.defineAsyncComponent('DsfWangEditor',()=>import(/*webpackChunkName:"platform_form"*/'./neweditor.vue')) 
export const DsfCodeEditor =dsf.defineAsyncComponent('DsfCodeEditor',()=>import(/*webpackChunkName:"platform_form"*/'./codeEditor.vue'))
export const DsfUEditor = dsf.defineAsyncComponent('DsfUEditor',()=>import(/*webpackChunkName:"platform_form"*/"./ueditor.vue"));  
export const DsfCarnumber = dsf.defineAsyncComponent('DsfCarnumber',()=>import(/*webpackChunkName:"platform_form"*/"./carNumber.vue"));  

// export const DsfTextbox=Vue.defineAsyncComponent(()=>import("./textbox.vue"))